import React, { forwardRef, useState } from "react";
import styled from "styled-components";
import emailjs from "emailjs-com";
import { SiGithub, SiLinkedin } from "react-icons/si";
import TextAnimation from "../animations/TextAnimateion";

const Contact = forwardRef<HTMLDivElement>((props, ref) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_nphs9cf",
        "template_0fn8jzi",
        e.target,
        "Hygul7yswni-7kVHC"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Message sent successfully!");
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send the message, please try again.");
        }
      );

    setFormData({ name: "", email: "", message: "" });
  };
  return (
    <AboutContainer ref={ref}>
      <TextAnimation>
        <Header>Contact Me</Header>
      </TextAnimation>
      <AboutText>
        <ContactSection>
          <ContactForm onSubmit={handleSubmit}>
            <FormField>
              <Label htmlFor="name">Name</Label>
              <Input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </FormField>
            <FormField>
              <Label htmlFor="email">Email</Label>
              <Input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </FormField>
            <FormField>
              <Label htmlFor="message">Message</Label>
              <Textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </FormField>
            <SubmitButton type="submit">Send Message</SubmitButton>
          </ContactForm>
          <ContactDetails>
            <DetailItem>
              Email:{" "}
              <a href="mailto:kamil.kamil.1995@wp.pl">
                kamil.wojciak.1995@gmail.com
              </a>
            </DetailItem>
            <DetailItem>
              Phone: <a href="tel:+48514519159">+48 514 819 159</a>
            </DetailItem>
            <SocialLinks>
              <a
                href="https://github.com/Kamildeeal?tab=repositories"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiGithubIcon />
                {""}GitHub
              </a>
              <a
                href="https://www.linkedin.com/in/kamil-wojciak-68bb54214/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiLinkedinIcon />
                LinkedIn
              </a>
            </SocialLinks>
          </ContactDetails>
        </ContactSection>
      </AboutText>
    </AboutContainer>
  );
});

export default Contact;

const AboutContainer = styled.div`
  width: 100%;
  height: auto;
  margin-top: 40px;
  & > h3 {
    color: white;
    font-size: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
    margin-top: 40px;
    margin-bottom: 5px;
    letter-spacing: 3px;
    font-style: oblique;
  }
`;
const Header = styled.h3`
  color: white;
  font-size: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  letter-spacing: 3px;
  font-style: oblique;

  @media (max-width: 460px) {
    margin-top: 10px;
  }
`;

const AboutText = styled.div`
  max-width: 100%;
  margin-right: 16px;
  margin-left: 20px;
  height: auto;
  border-radius: 8px;
  background: rgba(185, 185, 185, 0.44);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
  padding: 15px 15px;
  transition: all 0.1s ease;

  &:hover {
    background: rgba(36, 36, 41, 0.67);
  }
`;

const ContactSection = styled.section`
  padding: 5px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  // margin: 50px 0;
  text-align: center;
  color: white;
`;

// const ContactHeader = styled.h2`
//   font-size: 2rem;
//   margin: 10px 0px;
// `;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 15px;
`;

const FormField = styled.div`
  margin-bottom: 15px;
  width: 100%;
  max-width: 500px;
  text-align: left;
`;

const Label = styled.label`
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  font-size: 1.2rem;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;

const ContactDetails = styled.div`
  font-size: 1rem;
  margin-top: 20px;
`;

const DetailItem = styled.div`
  margin: 5px 0;

  & > a {
    color: white;
    font-size: 1.2rem;
  }
`;

const SocialLinks = styled.div`
  margin-top: 10px;

  & > a {
    margin: 0 10px;
    color: white;
    font-size: 1.2rem;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const SiGithubIcon = styled(SiGithub)`
  margin-right: 10px;
`;

const SiLinkedinIcon = styled(SiLinkedin)`
  margin-right: 10px;
`;
